import { RefObject, useEffect, useMemo, useRef } from 'react'

import { GridAnimationBackground } from './GridAnimationBackground'

export const useGridAnimationBackground = (ref: RefObject<any>) => {
  const runOnce = useRef<boolean>(false)
  const gridAnimationBackground = useMemo(() => new GridAnimationBackground(), [])

  useEffect(() => {
    if (!runOnce.current) {
      runOnce.current = true
      gridAnimationBackground.addAnimationByRef(ref)
      gridAnimationBackground.main()
    }

    return () => {
      gridAnimationBackground.unmount()
    }
  }, [gridAnimationBackground, ref])
}
